import { Injectable } from '@angular/core';
import { BaseHttpService } from '@core/data/http/base-http.service';
import { Observable, map, publishReplay, refCount } from 'rxjs';
import * as moment from 'moment';
import { environment } from '@environments/environment';
import { Country } from '@core/models/common/country';

@Injectable()
export class GlobalsDataService extends BaseHttpService {
    private urls: any = {
        geo: '/geo',
        industries: '/industries?all=true',
    };

    fetchIndustries(): Observable<any> {
        return this.get(this.urls.fetchIndustries);
    }

    fetchGlobals() {
        const cacheBuster: string = moment().format('YYYYMMDDHHmmss');
        return this.get(environment.assets.globalUrl + '?t=' + cacheBuster, {}, true);
    }

    fetchSettings() {
        const cacheBuster: string = moment().format('YYYYMMDDHHmmss');
        return this.get(environment.assets.settingsUrl + '?t=' + cacheBuster, {}, true);
    }

    fetchCountry(): Observable<any> {
        return this.get(this.urls.geo, undefined, true)
            .pipe(
                map((response: Country) => {
                    if (response) {
                        if (response.country_code === null && response.lat === null && response.lng === null) {
                            response = new Country();
                            response.country_code = 'AU';
                            response.lat = -37.810298919678;
                            response.lng = 144.95440673828;
                        }
                    } else {
                        response = Object.assign(new Country(), response);
                    }

                    return response;
                }),
                publishReplay(1),
                refCount()
            );
    }

    fetchDatetimeFormats() {
        const cacheBuster: string = moment().format('YYYYMMDDHHmmss');
        return this.get(environment.assets.formatUrl + '?t=' + cacheBuster, {}, true);
    }
}
